import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loading-state',
    templateUrl: './loading-state.component.html',
    styleUrls: ['./loading-state.component.scss']
})
export class LoadingStateComponent {

    @Input() text = 'Cargando...';
    @Input() size: 'sm' | 'md' | 'lg' = 'md';
}
